import { DateTime } from 'luxon';
import { ApprovalStatus } from '@hooks/useAlbumInfo/types';
import { useApprovalStatusCopy } from '@hooks/useApprovalStatusCopy';
import { formatDate } from '@helpers/dateTimeUtils';

export function useApprovalStatusLabel(status?: ApprovalStatus): string {
  const copy = useApprovalStatusCopy();
  switch (status) {
    case ApprovalStatus.APPROVED:
      return copy.approved;
    case ApprovalStatus.DECLINED:
      return copy.declined;
    case ApprovalStatus.PARTIALLY_APPROVED:
      return copy.partiallyApproved;
    case ApprovalStatus.NEEDS_APPROVAL:
      return copy.needsApproval;
    case ApprovalStatus.EXPIRED:
      return copy.expired;
    case ApprovalStatus.NOT_REQUIRED:
      return copy.noApprovalNeeded;
    case ApprovalStatus.DEFAULT_APPROVED:
      return copy.defaultApproved;
    case ApprovalStatus.REMOVED:
      return copy.removed;
    default:
      return '–';
  }
}

export function formatApprovalDecisionDate(
  isoString?: string,
): string | undefined {
  if (!isoString) return undefined;
  return formatDate(DateTime.fromISO(isoString), "MMMM d, yyyy 'at' h:mma");
}
